import { useState, useEffect } from "react";
import { Outlet, useNavigate } from "react-router-dom";

import Button from "@components/Button";
import PageTitle from "@components/PageTitle";

import PathContants from "@routers/pathConstants";
import "./style.scss";

export default function MeLayout() {
	const navigate = useNavigate();

	const [activeButton, setActiveButton] = useState<string>("");

	useEffect(() => {
		if (location.pathname === PathContants.MeDetail) {
			setActiveButton(PathContants.MeDetail);
		} else if (
			location.pathname.includes(PathContants.meInquiry) ||
			location.pathname.includes(PathContants.meInquiryDetail)
		) {
			setActiveButton(PathContants.meInquiry);
		}
	}, [location.pathname]);

	const handleGoToMeDetail = () => {
		navigate(PathContants.MeDetail);
		setActiveButton(PathContants.MeDetail);
	};

	const handleGoToMeInquiry = () => {
		navigate(PathContants.meInquiry);
		setActiveButton(PathContants.meInquiry);
	};

	return (
		<div className="me-layout">
			<PageTitle title="마이페이지" />
			<div className="me-layout__content">
				<div className="me-layout__content-navigation">
					<Button
						label="회원정보"
						color={activeButton === PathContants.MeDetail ? "white" : "black"}
						onClick={handleGoToMeDetail}
					/>
					<Button
						label="1:1 문의"
						color={activeButton.includes(PathContants.meInquiry) ? "white" : "black"}
						onClick={handleGoToMeInquiry}
					/>
				</div>
				<Outlet />
			</div>
		</div>
	);
}
